import React from "react";

// components
import { Heading } from "src/components";
import BlogList from "../BlogList/BlogList";

// styles
import styles from "./styles.module.scss";

const RelatedBlogs = ({ data }) => {
  return (
    <div className={styles.other__events__wrapper}>
      <Heading heading="Other related Blogs" to="/blogs" />
      <BlogList blogList={data?.length > 3 ? data?.slice(0, 3) : data} />
    </div>
  );
};

export default RelatedBlogs;
